import { usePage } from '@inertiajs/inertia-vue3';

export default {
    install: (app, options) => {
        Object.defineProperty(app.config.globalProperties, '$tenant', {
            get: () => usePage().props.value.app.user.org,
        });
    },
};
